'use client';

import { AnimatePresence } from 'motion/react';
import * as m from 'motion/react-m';
import { PropsWithChildren } from 'react';

import { Styles, css } from '@flipster/styled-system/css';
import { center, flex } from '@flipster/styled-system/patterns';

import CautionCircleIcon from '../icon/generated/CautionCircleIcon';

export interface ExplainProps extends PropsWithChildren {
  css?: Styles;
  hideIcon?: boolean;
}
const ExplainBase = ({ children, css: cssProps }: ExplainProps) => {
  return (
    <AnimatePresence mode='popLayout'>
      {children && (
        <m.div
          className={css(flex.raw({ textStyle: 'Text/M/Regular', whiteSpace: 'pre-wrap' }), cssProps)}
          initial={{ y: -2, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 4, opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          {children}
        </m.div>
      )}
    </AnimatePresence>
  );
};

const ExplainWarning = (props: ExplainProps) => {
  return (
    <Explain css={{ color: 'content.state.warning', ...props.css }}>
      {props.children && (
        <>
          {!props.hideIcon && (
            <div className={center({ mr: 2 })}>
              <CautionCircleIcon size={16} />
              <wbr />
            </div>
          )}
          {props.children}
        </>
      )}
    </Explain>
  );
};

const ExplainError = (props: ExplainProps) => {
  return <Explain css={{ color: 'content.state.negative', ...props.css }}>{props.children}</Explain>;
};

export const Explain = Object.assign(ExplainBase, {
  Warning: ExplainWarning,
  Error: ExplainError,
});
